import { Container } from '@soteria/design-system-ve';
import type { PropsWithChildren, CSSProperties, ReactNode } from 'react';

import { layoutContainer } from './Layout.css';

/**
 * BaseLayout props interface
 * Uses ReactNode instead of ReactElement for better compatibility
 */
interface BaseLayoutProps {
  children: ReactNode;
  header?: ReactNode;
  footer: ReactNode;
  className?: string;
  style?: CSSProperties;
}

/**
 * BaseLayout component
 * Provides the foundation for all other layout components
 *
 * The main content area is constrained to xxl (1920px) max-width
 * and centered. This provides consistent width for all page content
 * including hero images.
 */
export function BaseLayout({ children, header, footer, className = '', style = {} }: PropsWithChildren<BaseLayoutProps>) {
  return (
    <Container as="div" className={layoutContainer} padding="none" size="full" style={style}>
      {header}
      <Container as="main" className={className} padding="none" size="xxl">
        {children}
      </Container>
      {footer}
    </Container>
  );
}
